import { defineStore } from "pinia";
import Services from '@/services/sacrificerServices'
import { mapSacrificer } from '@/helpers/mapFuncs'

export const useSacrificerStore = defineStore("sacrificer", {

state:()=>({
    sacrificer: {},
    sacrificers: [],
}),
getters : {
    getSacrificer() {
        return mapSacrificer(this.sacrificer)
    },
    getSacrificers() {
        return this.sacrificers.map(mapSacrificer)
    }
},
actions : {
    /** Start Sets */
    setSacrificer(sacrificer) {
        this.sacrificer = sacrificer
    },
    setSacrificers(sacrificers) {
        this.sacrificers = sacrificers
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setSacrificer(response.data.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setSacrificers(response.data)
            return response
        })
    },
    getFamilyByPersonId(id) {
        return Services.getFamilyByPersonId(id)
        .then((response)=>{
            let data = response.data.data.sacrificer;
            data.members = response.data.data.member;
            this.setSacrificer(data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.sacrificers.push(response.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.sacrificers[this.sacrificers.findIndex((x)=>x.id == id)] = response.data.data?.person
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.sacrificers = this.sacrificers.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});